import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "../common/useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";
import ViewStationsModal from "../audioadminmanagment/ViewStationsModal";

const TrackCoupon = (props) => {
  const [campaigns, handleCampaignList] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [couponCode, handleCouponCode] = useState(
    props && props.couponCode ? props.couponCode : ""
  );
  const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);

  const userEmail = useRef(undefined);
  const searchStation = useRef(undefined);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const [totalCost, handleTotalCost] = useState(0);
  const [totalDisCount, handleTotalDiscount] = useState(0);
  // const packagetype = useRef(undefined);

  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  }, []);

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    try {
      var paramsConstrct;
      if (props.campaign) {
        let result = props.campaign.map((campaign) => {
          return calculateAmountAndTax(campaign);
        });
        handleCampaignList(result);
        handleCount(result.length);
        return;
      }
      if (!reset) {
        paramsConstrct = {
          skip: 0,
          couponCode: couponCode,
          sallerId: userEmail.current.value,
          station: searchStation.current.value,
        };
      }
      handleSkip(skip);
      const data = await Axios.get(endPoints.getcouponCampaigs, {
        params: paramsConstrct,
      });
      let result = data.data.data;
      if (result) {
        let totalCost = await result.reduce((totalCost, campaign) => {
          return parseInt(totalCost) + parseInt(campaign.totalCost);
        }, 0);
        let totalDisCount = await result.reduce((totalCost, campaign) => {
          return parseInt(totalCost) + parseInt(campaign.couponDiscount);
        }, 0);
        handleTotalCost(totalCost);
        handleTotalDiscount(totalDisCount);
        handleCampaignList(result);
        handleCount(data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const callSearch = () => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  };

  const hideshowstations = (e) => {
    handleshowstationlist(!showstationlist);
  };
  const clearSearch = () => {
    window.location.reload(true);
  };

  //Return the table for campaign
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>{" "}
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Coupon Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Track Coupons{" "}
                </span>{" "}
              </div>
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="search_camp search_list search-container">
                        <input
                          type="text"
                          onChange={(e) => {
                            handleCouponCode(e.target.value);
                          }}
                          value={couponCode}
                          placeholder="Enter Coupon Code"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="search_camp search_list search-container">
                        <input
                          type="text"
                          ref={userEmail}
                          placeholder="Enter Sales Representative ID"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="search_camp search_list search-container">
                        <input
                          type="text"
                          ref={searchStation}
                          placeholder="Enter Station"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="print_btn">
                        <button type="button" onClick={callSearch}>
                          Search{" "}
                        </button>
                      </div>{" "}
                    </td>
                    <td>
                      <div className="print_btn">
                        {" "}
                        {/***  <button type="button" onClick={clearSearch}>Clear</button>*/}{" "}
                        <button type="reset" onClick={clearSearch}>
                          {props.couponCode && "Back to Coupon View"}
                          {!props.couponCode && "Clear"}
                        </button>{" "}
                      </div>{" "}
                    </td>
                  </tr>{" "}
                </tbody>{" "}
              </table>{" "}
            </form>{" "}
            <div className="dashboard-content userListing-dashboard bg-white table-responsive">
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th> Campaign Id </th> <th> Campaign Name </th> <th> Coupon Code </th>{" "}
                    <th> Station </th><th>Company Name</th><th>Customer Email</th> <th>Sales Associate Id </th>{" "}
                    <th> Campaign Amount </th> <th> Discount Amount </th>{" "}
                    <th className="txt-cntr"> Coupon Generated By </th>
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {" "}
                  {campaigns.map((c, i) => (
                    <tr key={i}>
                      <td>{c._id}</td>
                      <td>{c.name}</td>
                      <td>{c.couponCode}</td>
                      <td>{c.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  handleshowstationlist(true);
                                  handleCurrentStations(c.station.split(","));
                                }}
                              >
                                Multiple ({c.station.split(",").length})
                              </a>
                            ) : (
                              c.station
                            )} </td>
                  <td>{c.userDetails && c.userDetails.length > 0 &&c.userDetails[0].company}</td>
                      <td>{c.userEmail}</td>
                      <td>{c.sallerId}</td>
                      <td>{c.totalCost}</td>
                      <td>{c.couponDiscount}</td>
                      <td>
                        {c.coupon &&
                          c.coupon.length > 0 &&
                          c.coupon[0].userEmail}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td>
                      <b>Total</b>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <b>{totalCost}</b>
                    </td>
                    <td>
                      <b>{totalDisCount}</b>
                    </td>
                    <td></td>
                  </tr>
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {campaigns.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}
        </div>{" "}
      </div>
      {showstationlist && (
                <ViewStationsModal
                  stations={currentStations}
                  closeAction={hideshowstations}
                />
              )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(TrackCoupon);



// WEBPACK FOOTER //
// ./web/components/admin/manageCoupon/trackcoupon.js